import { accountWalletReload } from '../actions/account';
import { APP_INIT, ACCOUNT_WALLET_SELECT, ACCOUNT_WALLET_RESET } from '../actionTypes';

const handleWallet = (storage, beforeState, afterState, action, { dispatch }) => {
  if (action.type === APP_INIT) {
    const walletSelection = storage.get('wallet-selection') || {
      walletType: '',
      walletOptions: {},
    };

    if (walletSelection.walletType) {
      dispatch(accountWalletReload(walletSelection.walletType, walletSelection.walletOptions));
    }
  }

  if (action.type === ACCOUNT_WALLET_SELECT) {
    storage.set('wallet-selection', {
      walletType: action.walletType,
      walletOptions: action.walletOptions,
    });
  }

  if (action.type === ACCOUNT_WALLET_RESET) {
    storage.set('wallet-selection', null);
  }
};

export default handleWallet;



// WEBPACK FOOTER //
// ./src/middleware/walletPersistence.js